import React from 'react';

/**
 * Generic button that smoothly scrolls the viewport to the element whose id
 * matches `targetId`.
 */
export default function ScrollButton({ targetId, className = 'btn', children }) {
  const handleClick = () => {
    const el = document.getElementById(targetId);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <button type="button" className={className} onClick={handleClick}>
      {children}
    </button>
  );
}